import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "black",
        color: "#737373",
        textAlign: "center",
        py: 5,
        mt: 8,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          textTransform: "uppercase",
          letterSpacing: "0.2em",
          fontSize: "0.68rem",
        }}
      >
        © 2026 Lemanade. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
